import { useCookies } from "react-cookie";
export const TOKEN_NAME = "studies_access_token";
export const useAuthToken = () => {
  const [cookies, setCookie, removeCookie] = useCookies([TOKEN_NAME]);
  const setAuthToken = (authToken: any) => setCookie(TOKEN_NAME, authToken, { path: '/' });
  const removeAuthToken = () => removeCookie(TOKEN_NAME, { path: '/' });
  return [cookies[TOKEN_NAME], setAuthToken, removeAuthToken];
};
